import { Modal } from '../Common/Modal';
import { SkeletonLoader } from '../Common/SkeletonLoader';

const OnePaymentSkeletonLoader = () => {
  return (
    <Modal>
      <div className="w-full md:w-[43%] h-full bg-base-content rounded-xl p-6 mx-auto">
        <div className="flex flex-col gap-8 w-full max-w-4xl mx-auto mt-10">
          <div className="flex items-center gap-4 justify-between">
            <div className="flex items-center gap-4">
              <SkeletonLoader width="w-11" height="h-11" />
              <SkeletonLoader width="w-24" height="h-5" />
            </div>
            <div className="flex items-center gap-2">
              <SkeletonLoader width="w-12" height="h-3" />
              <SkeletonLoader width="w-3" height="h-3" />
            </div>
          </div>

          <div className="flex flex-col gap-5">
            <div className="flex items-center justify-between gap-4">
              <div className="flex items-center gap-4">
                <SkeletonLoader width="w-14" height="h-5" />
              </div>
              <SkeletonLoader width="w-14" height="h-5" />
            </div>

            <SkeletonLoader height="h-10" />
            <SkeletonLoader height="h-10" />

            <div className="grid grid-cols-2 gap-3">
              <SkeletonLoader height="h-10" />
              <SkeletonLoader height="h-10" />
            </div>

            <SkeletonLoader height="h-5" />
            <SkeletonLoader height="h-10" />
          </div>
          <div className="flex  justify-center">
            <SkeletonLoader height="h-5" width="w-36" />
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default OnePaymentSkeletonLoader;
